import * as React from "react";
import { Redirect, Route } from "react-router";
import { observer } from "mobx-react-lite";
import { DefaultRoutes } from "./routes";
import { useMst } from "./mobx";

interface AuthProps {
  component: React.FC;
}

export const AuthorizationRoute = observer(({ component: Component, ...rest }: AuthProps) => {
  const { authStore } = useMst();
  const { isLogged } = authStore;

  function renderRoute(props: any): React.ReactNode {
    return isLogged ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{
          pathname: `/${DefaultRoutes.login}`,
          state: {
            from: props.location,
          },
        }}
      />
    );
  }

  return <Route {...rest} render={renderRoute} />;
});
